import styled from "@emotion/styled";
import {Options} from "highcharts";

import {RequestStatus} from "../../../common/app/constants/enums";
import {placeholderMonthData} from "../../../common/app/constants/placeholder_charts_data";
import {BarChart} from "../Bar";
import {PieChart} from "../Pie";

export const PieBarChartPlaceholder = () => (
    <StyledPieBarChartPlaceholder>
        <PieChart
            data={placeholderMonthData}
            dataStatus={RequestStatus.SUCCESS}
            colorSet="alternate"
            height={200}
            fields={["value1", "value2", "value3", "value4", "value5"]}
            customOptions={options}
        />

        <BarChart
            data={placeholderMonthData}
            dataStatus={RequestStatus.SUCCESS}
            colorSet="purple"
            height={225}
            fields={["value1", "value2", "value3", "value4", "value5"]}
            customOptions={options}
        />
    </StyledPieBarChartPlaceholder>
);

const StyledPieBarChartPlaceholder = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    & > div {
        flex-basis: 50%;
    }
`;

const options: Options = {
    tooltip: {
        enabled: false
    }
};
